import { defineStore } from 'pinia';
import type {
  ICmsGlobalConfig,
  ICmsGlobalConfigMenuItems,
  ICmsGlobalConfigMenuItemsFooter,
} from '~~/types/_cms-types';

type TStoreState = {
  globalConfig?: ICmsGlobalConfig;
};

// Fallback Menu
const defaultTopMenu = [
  { label: 'Actueel', url: '/' },
  { label: 'Opiniepanel', url: '/opiniepanel' },
  { label: 'Uitzendingen', url: '/uitzendingen' },
  { label: 'Doe mee', url: '/doe-mee' },
  { label: 'Contact', url: '/contact-160003' },
];
const defaultFooterMenu = [
  { label: 'Over EenVandaag', url: '/over-eenvandaag-160005' },
  { label: 'Privacy Statement', url: 'https://www.avrotros.nl/privacy~51', external: true },
  { label: 'Richtlijnen Webchat', url: '/richtlijnen-webchat-160006' },
  { label: 'RSS Feed', url: '/feed.rss' },
  { label: 'Disclaimer', url: '/disclaimer-160007' },
  { label: 'Cookies', url: '/paginas/cookies-160071' },
];

const useGlobalConfigStore = defineStore('global_config', {
  state: (): TStoreState => {
    return {
      globalConfig: undefined,
    };
  },
  actions: {
    async fetchSettings() {
      const data = await useSingleton('global_config');
      this.$state.globalConfig = data || undefined;

      return this.$state.globalConfig;
    },
  },
  getters: {
    settings: (state) => state.globalConfig,
    menu: (state) => {
      if (state.globalConfig?.topbarMenu) {
        return mapMenuItems(state.globalConfig?.topbarMenu);
      }
      return defaultTopMenu;
    },
    footerMenu: (state) => {
      if (state.globalConfig?.footerMenu) {
        return mapMenuItems(state.globalConfig?.footerMenu);
      }
      return defaultFooterMenu;
    },
    footerBanners: (state) => state.globalConfig?.footerBanners,
    modal: (state) => state.globalConfig?.messageModal,
  },
});

const mapMenuItems = (menu: Array<ICmsGlobalConfigMenuItems | ICmsGlobalConfigMenuItemsFooter>) => {
  return menu.map((item) => {
    return {
      label: item.menuItemsId?.label || '', // Preserve label and other fields
      url: item.menuItemsId?.url || '#',
      external: item.menuItemsId?.isExternal || false,
    };
  });
};

export default useGlobalConfigStore;
